import React, { Component } from 'react';
import $ from "jquery";

class AreYouAgreeModal extends Component {

    CloseAreYouAgreeModal = async () => {
        const { cancel } = this.props;
        cancel();
        $('#areYouAgreeModal').modal('hide');
    };

    Accept = async () => {
        const { accept } = this.props;
        accept();
        $('#areYouAgreeModal').modal('hide');
    };

    render() {
        const {
            mensaje
            , option
            , currCashCut
            , onChange
        } = this.props;

        return (
            <div className="modal fade bd-example-modal-md modal-open scroll" id="areYouAgreeModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="areYouAgreeModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-md modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: 'black', color: '#FFFFFF' }}>
                            <h5 className="modal-title">Aviso</h5>
                            <button type="button" onClick={() => { this.CloseAreYouAgreeModal() }} style={{ color: "#FFFFFF", opacity: 1, margin: 0, padding: 0 }} className="close" aria-label="Close">
                                <span aria-hidden="true" style={{ color: 'white', fontSize: '20px' }}>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-1">
                                    </div>
                                    <div className="col-10">
                                        <div className="w-100 tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <h4 style={{ whiteSpace: 'pre-line' }} >{mensaje}</h4>
                                        </div>
                                    </div>
                                    <div className="col-1">
                                    </div>
                                </div>
                                {option && (Number(currCashCut?.ItemsGranel ?? 0) > 0) &&

                                    <div className="row justify-content-around">
                                        <div className="col-1">
                                        </div>
                                        <div className="col-10">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Densidad</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={onChange}
                                                    value={currCashCut?.U_RS_DENSIDAD ?? ''}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-1">
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect"
                                onClick={this.Accept}>
                                {option === 'CloseCutInventory' ? 'Si, revisar inventario' : 'Aceptar'}
                            </button>
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={this.CloseAreYouAgreeModal}>
                                {option === 'CloseCutInventory' ? 'Continuar con el cierre' : 'Cancelar'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AreYouAgreeModal;